import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import { QueryStatus } from '@reduxjs/toolkit/query';
import React from 'react';

interface Props {
  readonly status: QueryStatus;
  readonly noContentView: React.ReactElement;
  readonly noResultsView: React.ReactElement;
  readonly errorView?: React.ReactElement;
  readonly data: readonly unknown[];
  readonly filtersCount: number;
}

export const TableContentSelector: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactNode => {
  const { status, data, filtersCount, noContentView, errorView, noResultsView, children } = props;

  switch (status) {
    case QueryStatus.uninitialized:
    case QueryStatus.pending:
      return (
        <Box sx={styles.loadingContainer}>
          <CircularProgress size={64} thickness={4} color="inherit" />
        </Box>
      );
    case QueryStatus.rejected:
      return errorView ?? noContentView;
    case QueryStatus.fulfilled:
      if (data.length === 0 && filtersCount === 0) {
        return noContentView;
      } else if (data.length === 0) {
        return noResultsView;
      } else {
        return children;
      }
    default:
      return children;
  }
};

const styles: Record<string, SystemStyleObject> = {
  loadingContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'custom.LightGray',
  },
};
